<template>
<div>
  <el-form inline :model="searchForm">
    <el-form-item label="手机号">
      <el-input placeholder="多个可以用逗号分割" v-model="searchForm.phones">
        <div slot="suffix" class="el-icon-circle-plus" style="color: dodgerblue; margin-top: 0.5rem; padding-right: 0.5rem; font-size: 150%" @click="addMore(0)" />
      </el-input>
    </el-form-item>
    <el-form-item label="姓名">
      <el-input v-model="searchForm.names" placeholder="多个可以用逗号分割">
        <div slot="suffix" class="el-icon-circle-plus" style="color: dodgerblue; margin-top: 0.5rem; padding-right: 0.5rem; font-size: 150%" @click="addMore(1)" />
      </el-input>
    </el-form-item>
    <el-form-item label="工号">
      <el-input v-model="searchForm.staffNos" placeholder="多个可以用逗号分割">
        <div slot="suffix" class="el-icon-circle-plus" style="color: dodgerblue; margin-top: 0.5rem; padding-right: 0.5rem; font-size: 150%" @click="addMore(2)" />
      </el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="search" icon="el-icon-search">查询</el-button>
      <el-button @click="reset" icon="el-icon-refresh-right">重置</el-button>
    </el-form-item>
  </el-form>
  <el-row style="display: flex">
    <el-button icon="el-icon-plus" @click="addNewEmployee">新增员工</el-button>
    <el-button icon="el-icon-delete" @click="deleteByItems">批量删除</el-button>
    <el-upload action="/upload/file"
               style="margin-left: 10px;width: 100px"
               :show-file-list="false"
               :on-success="handleFileUploadSuccess">
      <el-button icon="el-icon-document-add">导入</el-button>
    </el-upload>
<!--    <el-button icon="el-icon-document-remove">导出</el-button>-->
    <div style="flex: 1">
    </div>
  </el-row>
  <el-table :data="list" style="width: 100%; margin-top: 1rem" border
            :header-cell-style="{background:'#eee',color:'black'}"
            max-height="600"
            ref="tableView"
  >
    <el-table-column v-for="(item, index) in listKeyMap"
                     :key="index"
                     :prop="item.key"
                     :label="item.title"
                     :width="item.width"
                     :fixed="item.flex"
                     v-if="item.type !== 3"
                     :type="item.type === 2?'selection':''"
    >
    </el-table-column>
    <el-table-column v-for="(item, index) in listKeyMap"
                     :key="index"
                     :prop="item.key"
                     :label="item.title"
                     :width="item.width"
                     fixed="right"
                     v-if="item.type === 3"
                     :type="item.type === 2?'selection':''"
    >
      <template slot-scope="scope">
        <el-button v-for="(actionItem, actionIndex) in item.actions" :key="'btn_' + actionIndex" size="mini" :type="actionItem.btnType" @click="btnAction(actionItem, scope.row)">
          {{actionItem.title}}
        </el-button>
      </template>
    </el-table-column>
  </el-table>
  <el-pagination style="margin-top: 1rem"
                 :page-size.sync="pageSize"
                 :total.sync="totalCount"
                 :current-page.sync="curPage"
                 @size-change="search"
                 @current-change="search"
                 :page-sizes="[20, 100, 200, 500, 1000]"
                 layout="total, sizes, prev, pager, next, jumper"
  />
  <el-dialog title="批量操作" :visible.sync="showMultipleEditBox">
    <el-card shadow="never" style="flex-wrap: wrap; justify-content: space-around">
    <el-tag v-for="(tag, index) in accountTags" :key="index" closable style="margin: 0.2rem">
      {{tag}}
    </el-tag>
      <el-input ref="multipleInput" style="margin: 0.2rem; width: 120px" size="small" v-model="multipleEditName" placeholder="新增-回车保存" @keyup.enter.native="change"/>
    </el-card>
    <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="doneAction">确 定</el-button>
        <el-button @click="clearAction">清 除</el-button>
      </span>
  </el-dialog>
  <el-dialog :visible.sync="showEditEmployee" :title="editEmployeeTitle" width="30%">
    <el-form :model="employeeInfo" label-width="80px">
      <el-form-item label="手机号" :required="employeeAddOrEdit === true">
        <el-input placeholder="请输入手机号" v-model="employeeInfo.phone" :disabled="!employeeAddOrEdit"/>
      </el-form-item>
      <el-form-item label="姓名" required>
        <el-input placeholder="请输入姓名" v-model="employeeInfo.name"/>
      </el-form-item>
      <el-form-item label="角色" required>
        <el-select v-model="employeeInfo.roleType" placeholder="请选择角色">
          <el-option
            v-for="item in roleTypes"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="性别" required>
        <el-select v-model="employeeInfo.gender" placeholder="请选择性别">
          <el-option
            v-for="item in genderType"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="邮箱">
        <el-input placeholder="请输入邮箱" v-model="employeeInfo.email"/>
      </el-form-item>
      <el-form-item label="工号">
        <el-input placeholder="请输入工号" v-model="employeeInfo.staffNo"/>
      </el-form-item>
      <el-form-item label="备注">
        <el-input type="textarea" v-model="employeeInfo.remark" multiline/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitSaveAction">确 定</el-button>
        <el-button @click="showEditEmployee=false">取 消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</div>
</template>

<script>
import {add, deleteByIds, importByUrl, operationByPath, queryEmployee, update} from './employeeApi'

export default {
  name: 'employee',
  data () {
    return {
      accountTags: [],
      list: [],
      listKeyMap: [],
      searchForm: {
        curPage: 1,
        pageSize: 20,
        phones: '',
        names: '',
        staffNos: ''
      },
      roleTypes: [{
        id: 1,
        text: '管理员'
      },
      {
        id: 3,
        text: '普通员工'
      }],
      genderType: [
        {
          id: 1,
          text: '男'
        },
        {
          id: 2,
          text: '女'
        }
      ],
      multipleEditName: '',
      multipleEditBoxType: 0, // 0 手机/姓名/邮箱 1工号
      showMultipleEditBox: false,
      showEditEmployee: false,
      editEmployeeTitle: '编辑',
      employeeAddOrEdit: false,
      employeeInfo: {phone: '', email: '', name: '', staffNo: '', remark: '', roleType: null, gender: null},
      curPage: 1,
      totalCount: 0,
      totalPage: 0,
      pageSize: 20
    }
  },
  created () {
    this.search()
  },
  methods: {
    keyForType (type) {
      if (type === 0) {
        return 'phones'
      } else if (type === 1) {
        return 'names'
      } else if (type === 2) {
        return 'staffNos'
      }
      return null
    },
    addMore (type) {
      this.multipleEditBoxType = type
      const key = this.keyForType(type)
      if (!key) {
        return
      }
      const text = this.searchForm[key]
      const tempArray = text.split(',')
      for (let i = tempArray.length - 1; i >= 0; i--) {
        const tempText = tempArray[i].trim()
        if (tempText.length === 0) {
          tempArray.splice(i, 1)
        }
      }
      this.accountTags = tempArray
      this.showMultipleEditBox = true
      setTimeout(() => {
        this.$refs.multipleInput.focus()
      }, 100)
    },
    doneAction () {
      this.showMultipleEditBox = false
      const key = this.keyForType(this.multipleEditBoxType)
      this.searchForm[key] = this.accountTags.join(',')
    },
    clearAction () {
      this.accountTags = []
    },
    change () {
      const tempName = this.multipleEditName.trim()
      if (tempName.length === 0) {
        return
      }
      if (this.accountTags.indexOf(tempName) < 0) {
        this.accountTags.push(tempName)
      }
      this.multipleEditName = ''
      this.$refs.multipleInput.focus()
    },
    addNewEmployee () {
      this.employeeAddOrEdit = true
      this.employeeInfo = {phone: '', email: '', name: '', staffNo: '', remark: ''}
      this.showEditEmployee = true
    },
    editEmployee (item) {
      this.employeeInfo = JSON.parse(JSON.stringify(item))
      this.employeeAddOrEdit = false
      this.showEditEmployee = true
    },
    reset () {
      this.searchForm.phones = ''
      this.searchForm.names = ''
      this.searchForm.staffNos = ''
    },
    search () {
      queryEmployee(this.searchForm).then(rsp => {
        const {code, message, result} = rsp
        if (code === 0) {
          const { pagination, values } = result
          const { list, curPage, pageSize, totalCount, totalPage } = pagination
          this.curPage = curPage
          this.pageSize = pageSize
          this.totalPage = totalPage
          this.totalCount = totalCount
          this.list = list
          this.listKeyMap = values
        } else {
          this.$message.error(message)
        }
      })
    },
    submitSaveAction () {
      if (this.employeeAddOrEdit === true) {
        this.submitAddEmployee()
      } else {
        this.submitUpdateEmployee()
      }
    },
    submitUpdateEmployee () {
      const name = this.employeeInfo.name.trim()
      if (name.length === 0) {
        this.$message.error('姓名不能为空')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '添加中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      update(this.employeeInfo).then(rsp => {
        loading.close()
        const {code, message} = rsp
        if (code === 0) {
          this.$message.success('更新成功')
          this.showEditEmployee = false
          this.search()
        } else {
          this.$message.error(message)
        }
      })
    },
    submitAddEmployee () {
      const phone = this.employeeInfo.phone.trim()
      if (phone.length === 0) {
        this.$message.error('手机号不能为空')
        return
      }
      const name = this.employeeInfo.name.trim()
      if (name.length === 0) {
        this.$message.error('姓名不能为空')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '添加中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      add(this.employeeInfo).then(rsp => {
        loading.close()
        const {code, message} = rsp
        if (code === 0) {
          this.$message.success('添加成功')
          this.showEditEmployee = false
          this.search()
        } else {
          this.$message.error(message)
        }
      })
    },
    replaceText (text, item, encode) {
      const keys = Object.keys(item)
      for (let i = 0; i < keys.length; i++) {
        const tempKey = keys[i]
        const matchText = '{' + tempKey + '}'
        const index = text.indexOf(matchText)
        console.log(tempKey + ' ' + index + ' ' + matchText)
        if (index >= 0) {
          if (encode === true) {
            text = text.replace(matchText, encodeURIComponent(item[tempKey]))
          } else {
            text = text.replace(matchText, item[tempKey])
          }
        }
      }
      return text
    },
    btnAction (action, item) {
      const { type } = action
      if (type === 0) {
        const { code } = action
        if (code === 'edit') {
          this.editEmployee(item)
        }
      } else if (type === 1) {
        const deleteAction = () => {
          let { actionLink } = action
          actionLink = this.replaceText(actionLink, item, true)
          operationByPath(actionLink).then(rsp => {
            const {code, message} = rsp
            if (code === 0) {
              this.search()
              this.$message.success('操作成功')
            } else {
              this.$message.error(message)
            }
          })
        }

        let { alertMsg } = action
        alertMsg = this.replaceText(alertMsg, item, false)
        this.$confirm(alertMsg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(deleteAction).catch(null)
      }
    },
    handleFileUploadSuccess (rsp) {
      const {code} = rsp
      if (code === 0) {
        // post request
        const { result } = rsp
        const { url } = result
        const data = {}
        data.link = url
        importByUrl(data).then(rsp => {
          const {code} = rsp
          if (code === 0) {
            this.$message.success('导入文件提交成功,稍后请在导入菜单中查看结果')
          } else {
            const {message} = rsp
            this.$message.error(message)
          }
        })
      } else {
        const {message} = rsp
        this.$message.error(message)
      }
    },
    deleteByItems () {
      const items = this.$refs.tableView.selection
      if (items === undefined || items.length === 0) {
        this.$message.error('请选择需要删除的数据')
        return
      }
      const deleteAction = () => {
        const ids = []
        for (let i = 0; i < items.length; i++) {
          const tempItem = items[i]
          const {employeeId} = tempItem
          ids.push(employeeId)
        }
        deleteByIds({ids: ids}).then(rsp => {
          const {code, message} = rsp
          if (code === 0) {
            this.search()
            this.$message.success('操作成功')
          } else {
            this.$message.error(message)
          }
        })
      }
      this.$confirm('确定要删除这些员工吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(deleteAction).catch(null)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/employee/employee.vue